import CommonProcess from 'app/components/OrderPayment/Common/CommonProcess';
import React from 'react';

const MobiliansPayment = () => {
  return <CommonProcess />;
};

export default MobiliansPayment;
